import request from '../utils/request';
const querystring = require('querystring')
 
//获取列表数据 
export const fetchData = query => {  
    var list = request({
        url: 'comMember/selectPage.do',
        method: 'post',
        data: querystring.stringify(query)
    }); 
    return list;
};

  
export const saveForm = query => {  
    var list = request({
        url: 'comMember/insert.do',
        method: 'post',
        data: querystring.stringify(query)
    }); 
    return list;
};
export const handelDelete = query => {   
    var list = request({
        url: 'comMember/delete.do',
        method: 'post',
        data: querystring.stringify(query)
    }); 
    return list;
};

export const updateSave = query => {  
    var list = request({
        url: 'comMember/update.do',
        method: 'post',
        data: querystring.stringify(query)
    }); 
    return list;
}; 
 

export const changeStatus = query => {  
    var list = request({
        url: 'comMember/changeStatus.do',
        method: 'post',
        data: querystring.stringify(query),  
    }); 
    return list;
};

export const changeOver = query => {  
    var list = request({
        url: 'comMember/changeOver.do',
        method: 'post',
        data: querystring.stringify(query),  
    }); 
    return list;
};
export const changeStatus2 = query => {  
    var list = request({
        url: 'comMemGoods/setStatus.do',
        method: 'post',
        data: querystring.stringify(query),  
    }); 
    return list;
};
export const changeStatus3 = query => {  
    var list = request({
        url: 'comMemGoods/setIsStop.do',
        method: 'post',
        data: querystring.stringify(query),  
    }); 
    return list;
};
export const changeStatus4 = query => {  
    var list = request({
        url: 'comMemGoods/changeRiskStatus.do',
        method: 'post',
        data: querystring.stringify(query),  
    }); 
    return list;
};

export const changeVal = query => {  
    var list = request({
        url: 'comMemGoods/update.do',
        method: 'post',
        data: querystring.stringify(query),  
    }); 
    return list;
};

export const setDeducPercent = query => {  
    var list = request({
        url: 'comMemGoods/setDeducPercent.do',
        method: 'post',
        data: querystring.stringify(query),  
    }); 
    return list;
};

export const changeStatusBatch = query => {  
    var list = request({
        url: 'comMemGoods/changeStatusMore.do',
        method: 'post',
        data: querystring.stringify(query),  
    }); 
    return list;
};


export const fetchSelect = query => {  
    var list = request({
        url: 'comMember/getListFetch.do',
        method: 'post',
        data: querystring.stringify(query),  
    }); 
    return list;
};

export const fetchSelectTM = query => {  
    var list = request({
        url: 'comMember/getListFetchTM.do',
        method: 'post',
        data: querystring.stringify(query),  
    }); 
    return list;
};
 




